/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarGroup } from '../../models/calendar-group';
import { CalendarGroupNew } from '../../models/calendar-group-new';

export interface CreateCalendarGroup$Params {
      body: CalendarGroupNew
}

export function createCalendarGroup(http: HttpClient, rootUrl: string, params: CreateCalendarGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarGroup>> {
  const rb = new RequestBuilder(rootUrl, createCalendarGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarGroup>;
    })
  );
}

createCalendarGroup.PATH = '/api/v1/calendars/groups';
